import { call, delay, put, takeLatest } from "redux-saga/effects";

// requests
import {
  createDepartmentApi,
  editDepartmentDataByIdApi,
  getDepartmentDataByIdApi,
  getDepartmentListApi,
} from "../../requests/master/departmentRequests";

// actions
import {
  getDepartmentList,
  setDepartmentDataById,
  setDepartmentList,
  setDepartmentListPageCount,
} from "../../../actions/master/departmentAction";
import { DepartmentActionTypes, DepartmentActions } from "../../../actionTypes/master/departmentActionTypes";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createDepartmentHandler(action: DepartmentActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createDepartmentApi, action.payload);
    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getDepartmentListHandler(action: DepartmentActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDepartmentListApi, action.payload);
    if (data.status) {
      yield put(setDepartmentList(data?.data?.rows));
      yield put(setDepartmentListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getDepartmentDataByIdHandler(action: DepartmentActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDepartmentDataByIdApi, action.payload);
    if (data.status) {
      yield put(setDepartmentDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editDepartmentDataByIdHandler(action: DepartmentActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editDepartmentDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getDepartmentList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* departmentSaga() {
  yield takeLatest(DepartmentActions.CREATE_DEPARTMENT, createDepartmentHandler);
  yield takeLatest(DepartmentActions.GET_DEPARTMENT_LIST, getDepartmentListHandler);
  yield takeLatest(DepartmentActions.GET_DEPARTMENT_DATA_BY_ID, getDepartmentDataByIdHandler);
  yield takeLatest(DepartmentActions.EDIT_DEPARTMENT_DATA_BY_ID, editDepartmentDataByIdHandler);
}
